import type {
  FoodEntry,
  ListResponse,
  MeResponse,
  User,
} from './types'

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(init?.headers ?? {}),
    },
  })
  if (!res.ok) {
    let body: unknown = undefined
    try {
      body = await res.json()
    } catch {}
    const message =
      (body as { error?: { message?: string } })?.error?.message ??
      `HTTP ${res.status}`
    throw new Error(message)
  }
  if (res.status === 204) return undefined as T
  return (await res.json()) as T
}

export const api = {
  me: async () => request<MeResponse>('/api/users/me'),
  logout: async () => request<void>('/api/auth/logout', { method: 'POST' }),
  listUsers: async () => request<User[]>('/api/users'),
  getUser: async (id: string) => request<User>(`/api/users/${id}`),
  listEntries: async (params: {
    userId?: string
    from?: string
    to?: string
    limit?: number
    offset?: number
  } = {}) => {
    const qs = new URLSearchParams()
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== '') qs.set(k, String(v))
    })
    const suffix = qs.toString() ? `?${qs}` : ''
    return request<ListResponse<FoodEntry>>(`/api/entries${suffix}`)
  },
  getEntry: async (id: string) => request<FoodEntry>(`/api/entries/${id}`),
}
